export default __webpack_public_path__ + "static/media/img-4507.d87fc9e8.jpeg";